import AdminTemplateRequests from "./AdminTemplateRequests";
import AuditLogs from "./AuditLogs";
import CompanySelector from "./CompanySelector";
import DemoData from "./DemoData";
import QueryCache from "./QueryCache";
import SubmissionAccessManager from "./SubmissionAccessManager";
import SubmissionEditor from "./SubmissionEditor";
import Transfers from "./Transfers";
import UserConfig from "./UserConfig";
import UserManagement from "./UserManagement";
import {
  Face as UsersIcon,
  FactCheckRounded as ConfigStagingIcon,
  PolicyRounded as AuditIcon,
  Settings as SettingsIcon,
  Storefront as TransferIcon,
  GradientRounded as CacheIcon,
  ListAlt as WhitelistsIcon,
  CodeRounded as JsonIcon,
  DescriptionRounded as TemplateRequestsIcon,
  DataObject as DemoDataIcon,
} from "@mui/icons-material";
import ConfigStagingPage from "components/admin/configStaging/ConfigStagingPage";
import Footer from "components/common/Footer";
import Navigation from "components/common/Navigation";
import { useState } from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";

const CompanyConsole = () => {
  const [navigationState, setNavigationState] = useState({});

  const { companyId } = useParams();

  const menuItems = [
    { text: "Settings", icon: <SettingsIcon />, route: "settings" },
    { text: "Users", icon: <UsersIcon />, route: "users" },
    { text: "Transfers", icon: <TransferIcon />, route: "transfers" },
    { text: "Caches", icon: <CacheIcon />, route: "query-cache" },
    {
      text: "Submissions",
      icon: <WhitelistsIcon />,
      route: "submission-access",
    },
    {
      text: "Edit Submission",
      icon: <JsonIcon />,
      route: "submission-editor",
    },
    {
      text: "Template Requests",
      icon: <TemplateRequestsIcon />,
      route: "template-requests",
    },
    {
      text: "Config Staging",
      icon: <ConfigStagingIcon />,
      route: "config-staging",
    },
    { text: "Logs", icon: <AuditIcon />, route: "audit-logs" },
    { text: "Demo Data", icon: <DemoDataIcon />, route: "demo-data" },
  ];

  return (
    <div className={"app"}>
      <Navigation
        menuItems={menuItems}
        rightMenuComponent={<CompanySelector companyId={companyId} />}
        parentRoute={`/admin/${companyId}`}
      />
      <Routes>
        <Route
          path={"settings/*"}
          element={
            <UserConfig
              navigationState={navigationState}
              setNavigationState={setNavigationState}
            />
          }
        />
        <Route path={"users/*"} element={<UserManagement />} />
        <Route path={"transfers/*"} element={<Transfers />} />
        <Route path={"audit-logs/*"} element={<AuditLogs />} />
        <Route path={"query-cache/*"} element={<QueryCache />} />
        <Route
          path={"submission-access/*"}
          element={<SubmissionAccessManager />}
        />
        <Route path={"submission-editor/*"} element={<SubmissionEditor />} />
        <Route
          path={"template-requests/*"}
          element={<AdminTemplateRequests companyId={companyId} />}
        />
        <Route path={"demo-data/*"} element={<DemoData />} />
        <Route
          path={"config-staging/*"}
          element={<ConfigStagingPage companyId={companyId} />}
        />
        <Route
          path={"*"}
          element={<Navigate to={"settings"} replace={true} />}
        />
      </Routes>
      <Footer />
    </div>
  );
};

export default CompanyConsole;
